import React, { Fragment, ReactNode } from 'react';

interface GuestGuardProps {
  children: ReactNode;
}
const GuestGuard = ({ children }: GuestGuardProps) => {
  return <Fragment>{children}</Fragment>;
};

export default GuestGuard;
